// assets/newsletter-popup.js
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.querySelector('.intc-newsletter-popup');
  
  if (!popup) return; // Exit if popup doesn't exist
  
  const hasSeenPopup = localStorage.getItem('intc-newsletter-popup-seen');
  
  // Show popup if user hasn't seen it
  if (!hasSeenPopup) {
    setTimeout(function() {
      popup.classList.add('intc-active');
    }, 20000); // 3 second delay
  }
  
  // Handle close button
  const closeButtons = document.querySelectorAll('.intc-popup-close, .intc-popup-newsletter-form button[type="submit"]');
  closeButtons.forEach(button => {
    button.addEventListener('click', function() {
      localStorage.setItem('intc-newsletter-popup-seen', 'true');
      popup.classList.remove('intc-active');
    });
  });
  
  // Optional: Close on overlay click
  const overlay = document.querySelector('.intc-popup-overlay');
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        localStorage.setItem('intc-newsletter-popup-seen', 'true');
        popup.classList.remove('intc-active');
      }
    });
  }
});